<template>
    <el-container class="main-layout">
        <el-aside :width="asideWidth" class="main-layout__aside better-scroller">
            <the-logo></the-logo>
            <the-sider-menu :collapsed="fold"></the-sider-menu>
        </el-aside>
        <el-aside class="main-layout__aside-placeholder float-left" :width="asideWidth"></el-aside>
        <el-container>
            <el-header height="60px" class="main-layout__header" :style="{ left: asideWidth }">
                <the-header :fold="fold" @changeFold="handleToggleFold"></the-header>
            </el-header>
            <div class="main-layout__header-placeholder"></div>
            <el-main class="main-layout__body">
                <the-breadcrumbs />
                <router-view />
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import TheLogo from '@layouts/main/components/TheLogo';
import TheSiderMenu from '@layouts/main/components/TheSiderMenu';
import TheHeader from '@layouts/main/components/TheHeader';
import TheBreadcrumbs from '@layouts/main/components/TheBreadcrumbs';
export default {
    name: 'MainLayout',
    components: { TheBreadcrumbs, TheHeader, TheSiderMenu, TheLogo },
    data() {
        return {
            fold: false
        };
    },
    computed: {
        asideWidth() {
            const { fold } = this;
            return fold ? '64px' : '160px';
        }
    },
    methods: {
        handleToggleFold(fold) {
            this.fold = fold;
        }
    }
};
</script>

<style lang="scss" scoped>
.main-layout {
    min-height: 100vh;
    background-color: #fff;
}

.main-layout__aside {
    position: fixed;
    z-index: 1002;
    left: 0;
    top: 0;
    height: 100vh;
    background: linear-gradient(0deg, #fff 0%, #AFD508 100%);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.main-layout__aside-placeholder {
    min-height: 100vh;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.main-layout__header {
    position: fixed;
    z-index: 1002;
    top: 0;
    right: 0;
    background-color: #fff;
    color: #656565;
    border-bottom: 1px solid #AFD508;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    //box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 111px;
        height: 79px;
        background: url('~@images/logo-extra-icon.png') no-repeat left top;
        background-size: 111px 79px;
    }
}

.main-layout__header-placeholder {
    height: 60px;
}

.main-layout__body {
    padding: 20px 32px 35px 40px;
}
</style>
